/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetUserSessionIssuerRequestBody = {
  /**
   * The user_session_issuer id to link, or null to unlink.
   */
  userSessionIssuerId?: string | undefined;
};

/** @internal */
export type SetUserSessionIssuerRequestBody$Outbound = {
  user_session_issuer_id?: string | undefined;
};

/** @internal */
export const SetUserSessionIssuerRequestBody$outboundSchema: z.ZodMiniType<
  SetUserSessionIssuerRequestBody$Outbound,
  SetUserSessionIssuerRequestBody
> = z.pipe(
  z.object({
    userSessionIssuerId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function setUserSessionIssuerRequestBodyToJSON(
  setUserSessionIssuerRequestBody: SetUserSessionIssuerRequestBody,
): string {
  return JSON.stringify(
    SetUserSessionIssuerRequestBody$outboundSchema.parse(
      setUserSessionIssuerRequestBody,
    ),
  );
}
